export const VERSION = typeof "3.0.8" !== 'undefined' ? "3.0.8" : 'latest';
//# sourceMappingURL=version.js.map